<app-dialog
  #dialog
  [key]="'pit-dismiss-finding'"
  [action]="'pit-dismiss-finding'"
  [headerTheme]="'simple'"
  [title]="'Dispensar ponto de atenção'"
  [appendTo]="'body'"
  [maxWidth]="'560px'">
  @if (finding(); as item) {
    <div class="pit-dismiss">
      <p>
        <b>{{ item.title }}</b>
      </p>
      <p class="pit-dismiss__help">
        O ponto sai dos principais deste ano e continua em "Ver mais pontos", riscado, com o seu
        nome e o motivo. Ele volta sozinho se a regra disparar de novo numa declaração nova, e pode
        ser reativado a qualquer momento.
      </p>
      <app-input
        [type]="'textarea'"
        [label]="'Motivo'"
        [placeholder]="'Ex.: laudo recebido por e-mail, conferido com o credor'"
        [maxLength]="500"
        [textCenter]="false"
        [(ngModel)]="reason"
        [ngModelOptions]="{ standalone: true }" />
    </div>
  }

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [label]="'Cancelar'"
        theme="outline-grey"
        [outlined]="true"
        [fitContent]="true"
        [disabled]="submitting()"
        (sendButtonClick)="dialogRef?.close()" />
      <app-button
        [label]="'Dispensar'"
        [fitContent]="true"
        [disabled]="!isFormValid()"
        [isLoading]="submitting()"
        (sendButtonClick)="submitAction()" />
    </div>
  </ng-template>
</app-dialog>
